import { baseApi } from "../api";

export interface UserSegmentsResponse {
	success: boolean;
	errorCode?: string;
	errorMessage?: string;
	dipTriggers?: string[];
	metadata?: {
		[key: string]: string;
	};
	now?: string;
	segmentIds: string[];
}

export const userSegmentsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		// The endpoint response is user-scoped even though the backend does not
		// need the user id as a request parameter. Including it in the cache key
		// prevents one user's segments from being reused for another user.
		getUserSegments: builder.query<UserSegmentsResponse, string | undefined>({
			query: () => "/rest/segments",
			providesTags: ["userSegmentsTag"]
		})
	})
});

export const { useGetUserSegmentsQuery } = userSegmentsApi;
